import { g as i } from "./generateUtilityClass-DMFG5-Cu.mjs";
function o(r, s, a = "Mui") {
  const t = {};
  return s.forEach((e) => {
    t[e] = i(r, e, a);
  }), t;
}
export {
  o as g
};
//# sourceMappingURL=generateUtilityClasses-CWIIr9E_.mjs.map
